export class NavigationService {
  private readonly baseUrl = window.location.origin;

  public NavigateTo(route: string, force?: boolean) {
    if (force) {
      window.onbeforeunload = null;
      window.removeEventListener('beforeunload', (window as any).ev_l_beforeUnload);
    }
    window.location.href = this.baseUrl + `/${route}`;
  }

  public ForceReload() {
    window.onbeforeunload = null;
    window.removeEventListener('beforeunload', (window as any).ev_l_beforeUnload);

    window.location.reload();
  }

  public NavigateExternal(route: string, force?: boolean) {
    if (force) {
      window.onbeforeunload = null;
      window.removeEventListener('beforeunload', (window as any).ev_l_beforeUnload);
    }
    window.location.href = route;
  }
}
